export default function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-router/~/history/~/@babel/runtime/helpers/esm/extends.js
// module id = 1095
// module chunks = 2 4 5 10 11 15